import 'simplebar-react/dist/simplebar.min.css'
import 'react-day-picker/style.css'

import 'setup/i18n'

import { StrictMode } from 'react'

import { CssBaseline } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'

import { ThemeProvider } from '@shared/components/ThemeProvider'
import { router } from 'pages/AppInit'
import { authService } from 'services/auth'
import { queryClient } from 'setup/react-query'

const DEV_AUTH_BYPASS = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true'

async function bootstrap() {
  if (!DEV_AUTH_BYPASS) {
    try {
      await authService.refresh()
    } catch {
      authService.login()
      return
    }

    authService.startAutoRefresh()
  }

  const rootElement = document.getElementById('root')
  const reactRoot = createRoot(rootElement!)

  reactRoot.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <CssBaseline enableColorScheme />
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}

bootstrap()
